



























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'SimpleConfirmModal' })
export default class SimpleConfirmModal extends Vue {
  @Prop({ required: true })
  title!: string

  @Prop({ default: '' })
  submitButton!: string

  @Prop({ default: '' })
  message!: string

  @Prop({ required: true })
  modalError!: string
}
